import { Text } from "@fluentui/react-northstar";
import React from "react";

export interface TextTableHeaderProps {
    content?: string;
}

export const TextTableHeader: React.FC<TextTableHeaderProps> = (props) => {
    return (
        <Text
            styles={({ theme: { siteVariables } }) => ({
                color: siteVariables.colorScheme.default.foreground5,
            })}
            size="medium"
        >
            {props.content}
        </Text>
    );
};
